<div *ngIf="person">
  <div>{{ person.name }}</div>
</div>
